import { ubacartTheme } from "@/common/theme/customers/ubacart.theme";
import { sparTheme } from "@/common/theme/customers/spar.theme";
import { budgensTheme } from "@/common/theme/customers/budgens.theme";
import { nisaTheme } from "@/common/theme/customers/nisa.theme";
import { centralcoopTheme } from "@/common/theme/customers/centralcoop.theme";
import { ThemeOptions } from "vuetify/types/services/theme";

export const themes: Record<string, ThemeOptions> = {
  ubacart: ubacartTheme,
  spar: sparTheme,
  budgens: budgensTheme,
  nisa: nisaTheme,
  centralcoop: centralcoopTheme,
};
